import styled from 'styled-components'
import { View } from '@tabeo/scarf'

export const Mobile = styled(View)`
  display: none;
  @media (max-width: 959px) {
    display: block;
  }
`

export const Desktop = styled(View)`
  display: none;
  @media (min-width: 960px) {
    display: block;
  }
`
